import React, { useState } from 'react';
import Card from '../components/common/Card';
import Table from '../components/common/Table';
import Badge from '../components/common/Badge';
import TradeCard from '../components/mobile/TradeCard';
import { formatDateTime, formatCurrency } from '../utils/formatters';
import { STATUS_COLORS, DIRECTION_COLORS } from '../utils/constants';
import tradesData from '../data/trades.json';
import useIsMobile from '../hooks/useIsMobile';

const TradesPage = () => {
  const [activeTab, setActiveTab] = useState('orders');
  const isMobile = useIsMobile();

  const orderColumns = [
    { header: '주문시간', accessor: 'orderTime', render: (row) => formatDateTime(row.orderTime) },
    { header: '종목', accessor: 'symbol' },
    { header: '구분', accessor: 'direction', render: (row) => (
      <span className={DIRECTION_COLORS[row.direction]}>{row.direction === 'Buy' ? '매수' : '매도'}</span>
    )},
    { header: '주문가격', accessor: 'orderPrice' },
    { header: '주문수량', accessor: 'orderQuantity', render: (row) => `${row.orderQuantity}계약` },
    { header: '체결수량', accessor: 'executedQuantity', render: (row) => `${row.executedQuantity}계약` },
    { header: '상태', accessor: 'status', render: (row) => (
      <Badge variant={STATUS_COLORS[row.status]}>{row.status}</Badge>
    )},
    { header: '주문번호', accessor: 'id' },
  ];

  const tradeColumns = [
    { header: '체결시간', accessor: 'executeTime', render: (row) => row.executeTime ? formatDateTime(row.executeTime) : '-' },
    { header: '종목', accessor: 'symbol' },
    { header: '구분', accessor: 'direction', render: (row) => (
      <span className={DIRECTION_COLORS[row.direction]}>{row.direction === 'Buy' ? '매수' : '매도'}</span>
    )},
    { header: '체결가격', accessor: 'executedPrice' },
    { header: '체결수량', accessor: 'executedQuantity', render: (row) => `${row.executedQuantity}계약` },
    { header: '수수료', accessor: 'commission', render: (row) => formatCurrency(row.commission) },
    { header: '손익', accessor: 'profitLoss', render: (row) => row.profitLoss ? (
      <span className={row.profitLoss >= 0 ? 'text-green-500' : 'text-red-500'}>
        {formatCurrency(row.profitLoss)}
      </span>
    ) : '-'},
    { header: '주문번호', accessor: 'id' },
  ];

  const filledTrades = tradesData.filter(t => t.status === 'Filled');

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-2xl sm:text-3xl font-bold">거래 내역</h2>

      <div className="flex space-x-2 sm:space-x-4 border-b border-gray-700">
        <button
          onClick={() => setActiveTab('orders')}
          className={`px-3 sm:px-4 py-2 font-medium text-sm sm:text-base ${activeTab === 'orders' ? 'text-blue-500 border-b-2 border-blue-500' : 'text-gray-400'}`}
        >
          주문 내역
        </button>
        <button
          onClick={() => setActiveTab('trades')}
          className={`px-3 sm:px-4 py-2 font-medium text-sm sm:text-base ${activeTab === 'trades' ? 'text-blue-500 border-b-2 border-blue-500' : 'text-gray-400'}`}
        >
          체결 내역
        </button>
      </div>

      {/* 거래 내역 - 모바일/데스크톱 분기 */}
      {isMobile ? (
        <div>
          {activeTab === 'orders' ? (
            tradesData.map((trade) => (
              <TradeCard key={trade.id} trade={trade} showProfit={false} />
            ))
          ) : (
            filledTrades.map((trade) => (
              <TradeCard key={trade.id} trade={trade} showProfit={true} />
            ))
          )}
        </div>
      ) : (
        <Card>
          {activeTab === 'orders' ? (
            <Table columns={orderColumns} data={tradesData} />
          ) : (
            <Table columns={tradeColumns} data={filledTrades} />
          )}
        </Card>
      )}
    </div>
  );
};

export default TradesPage;
